import { useEffect, useRef } from "react"

// Inspired from this answer: https://stackoverflow.com/questions/53120972/how-to-call-loading-function-with-react-useeffect-only-once/56767883#56767883
export default function useMountEffect(fn: () => void) {
  // workaround for useEffect triggering twice
  const hasRun = useRef(false)

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true
      fn()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
